// src/data/ollData.js
export const ollAlgorithms = [
  {
    id: 1,
    number: '01',
    image: require('@/pages/rubik/images/img96.png'),
    algorithm: `(RU2R')<br/>[sh]<br/>U2[sh]`,
    scramble: "(FR'F'R) U2 (FR'F') R2 U2 R'",
    scrambleClass: 'scramblok',
    categories: ['1piece'],
  },
  {
    id: 2,
    number: '02',
    image: require('@/pages/rubik/images/img102.png'),
    algorithm: `F[SX]<span class="mainColor3">F'</span><br/>f[SX]<span class="mainColor3">f'</span>`,
    scramble: '02+U2',
    scrambleClass: 'scramblok',
    categories: ['1piece'],
  },
  {
    id: 3,
    number: '03',
    image: require('@/pages/rubik/images/img108.png'),
    algorithm: `f[SX]<span class="mainColor3">f'</span><span class="mainColor2"> U'</span><br/>F[SX]<span class="mainColor3">F'</span>`,
    scramble: '04+U2',
    scrambleClass: 'scramblok',
    categories: ['2piece'],
  },
  {
    id: 4,
    number: '04',
    image: require('@/pages/rubik/images/img114.png'),
    algorithm: `f[SX]<span class="mainColor3">f'</span> U<br/>F[SX]<span class="mainColor3">F'</span>`,
    scramble: '03+U2',
    scrambleClass: 'scramblok',
    categories: ['2piece'],
  },
  {
    id: 5,
    number: '05',
    image: require('@/pages/rubik/images/img68.png'),
    algorithm: `(r'U2)(RUR'U)r`,
    scramble: '08, 12+U',
    scrambleClass: 'scramblok',
    categories: ['4piece', 'sshape'],
  },
  {
    id: 6,
    number: '06',
    image: require('@/pages/rubik/images/img74.png'),
    algorithm: `(r<span class="mainColor3">U'</span><span class="mainColor2">U'</span>)(R'<span class="mainColor2">U'</span>R<span class="mainColor2">U'</span>r')`,
    scramble: "07, 11+U', 13+U",
    categories: ['4piece', 'sshape'],
  },
  {
    id: 7,
    number: '07',
    image: require('@/pages/rubik/images/img80.png'),
    algorithm: `(rUR'U)(R<span class="mainColor3">U'</span><span class="mainColor2">U'</span>r')`,
    scramble: '06, 16',
    scrambleClass: 'scramble_orange',
    categories: ['4piece', 'sshape'],
  },
  {
    id: 8,
    number: '08',
    image: require('@/pages/rubik/images/img86.png'),
    algorithm: `(r'<span class="mainColor2">U'</span>R<span class="mainColor2">U'</span>)(R'U2r)`,
    scramble: '05, 10, 15',
    scrambleClass: 'scramble_orange',
    categories: ['4piece', 'sshape'],
  },
  {
    id: 9,
    number: '09',
    image: require('@/pages/rubik/images/img91.png'),
    algorithm: `[SX](R'FR)[SX]<span class="mainColor3">F'</span>`,
    scramble: "F (URU'R')(R'F'R)(URU'R')",
    scrambleClass: 'scramble_orange',
    categories: ['4piece'],
  },
  {
    id: 10,
    number: '10',
    image: require('@/pages/rubik/images/img64.png'),
    algorithm: `(RUR'<span class="mainColor">U</span>)<br/>[sh]<br/>(R<span class="mainColor2">U'</span><span class="mainColor2">U'</span>R')`,
    scramble: "14+U'",
    scrambleClass: 'scramble_orange',
    categories: ['4piece'],
  },
  {
    id: 11,
    number: '11',
    image: require('@/pages/rubik/images/img97.png'),
    algorithm: `(r'R2UR'U)(R<span class="mainColor3">U'</span><span class="mainColor2">U'</span>R'U)<span class="mainColor">M'</span>`,
    scramble: "M U'RU2<br/>(R'U'RU')<br/>R2r",
    scrambleClass: 'scramble',
    categories: ['4piece'],
  },
  {
    id: 12,
    number: '12',
    image: require('@/pages/rubik/images/img103.png'),
    algorithm: `<span class="mainColor">M'</span>(R'<span class="mainColor2">U'</span>R<span class="mainColor2">U'</span>)(R'U2R<span class="mainColor2">U'</span>)M`,
    scramble: "M'(UR'U2R)(UR'UR)M",
    scrambleClass: 'scramble',
    categories: ['4piece'],
  },
  {
    id: 13,
    number: '13',
    image: require('@/pages/rubik/images/img109.png'),
    algorithm: `f(RU)(R2<span class="mainColor2">U'</span>)(R'UR<span class="mainColor2">U'</span>)<span class="mainColor">f'</span>`,
    scramble: '09+U2<br/>[SX](R\'FR)[SX]<span class="mainColor3">F\'</span>U2',
    scrambleClass: 'scramble',
    categories: ['4piece', 'lshape1'],
  },
  {
    id: 14,
    number: '14',
    image: require('@/pages/rubik/images/img115.png'),
    algorithm: `f'(L'U')(L2 U)(L U' L' U)f`,
    algorithmOld: `(R'F)(RUR'<span class="mainColor3">F'</span>R)(F<span class="mainColor2">U'</span><span class="mainColor3">F'</span>)`,
    scramble: "(FUF')(R'FRU'R')(F'R)",
    scrambleClass: 'scramble',
    categories: ['4piece', 'lshape1'],
    cssOll: 'rotate180',
  },
  {
    id: 15,
    number: '15',
    image: require('@/pages/rubik/images/img69.png'),
    algorithm: `(l' U' l)<br/>[SX left]<br/>(l' U l)`,
    algorithmOld: `(r'<span class="mainColor2">U'</span>r)(R'<span class="mainColor2">U'</span>RU)(r'Ur)`,
    scramble: "(r'U'r)(U'R'UR)(r'Ur)",
    scrambleClass: 'scramble_orange',
    categories: ['4piece', 'lshape1'],
    cssOll: 'rotate180',
  },
  {
    id: 16,
    number: '16',
    image: require('@/pages/rubik/images/img75.png'),
    algorithm: `(r U r')<br/>[SX]<br/>(r <span class="mainColor2">U' </span><span class="mainColor">r'</span>)`,
    scramble: "(r U r')(U R U' R')(r U' r')",
    scrambleClass: 'scramble_orange',
    categories: ['4piece', 'lshape1'],
  },
  {
    id: 17,
    number: '17',
    image: require('@/pages/rubik/images/img81.png'),
    algorithm: `(l<span class="mainColor2">U'</span>l')f(R2BR'UR'<span class="mainColor2">U'</span><span class="mainColor3">f'</span>)`,
    note: '<span style="color: #00a650">OR</span><br/>f[SX]f\' + U\'[SX][sh]',
    scramble: '19',
    scrambleClass: 'scramble_learn',
    categories: ['3piece', 'lineshape'],
  },
  {
    id: 18,
    number: '18',
    image: require('@/pages/rubik/images/img87.png'),
    algorithm: `(rUR'U)(R<span class="mainColor3">U'</span><span class="mainColor2">U'</span>r')(r'<span class="mainColor2">U'</span>R<span class="mainColor2">U'</span>)(R'U2r)`,
    note: '<span style="color: #00a650">OR</span><br/>U f[SX]2 f\' U2 f [SX] f\'',
    scramble: "F [SX] F' U2 F [SX]2 F' U or 17",
    scrambleClass: 'scramble_learn',
    categories: ['3piece'],
  },
  {
    id: 19,
    number: '19',
    image: require('@/pages/rubik/images/img92.png'),
    algorithm: `MU [SX]<br/>M' [sh]`,
    scramble: '18',
    scrambleClass: 'scramble_orange',
    categories: ['3piece'],
  },
  {
    id: 20,
    number: '20',
    image: require('@/pages/rubik/images/img65.png'),
    algorithm: `(rUR'<span class="mainColor2">U'</span>)<span class="mainColor">M'2</span>U(R<span class="mainColor2">U'</span>R'<span class="mainColor2">U'</span>)<span class="mainColor">M'</span>`,
    scramble: '20',
    scrambleClass: 'scramblok',
    categories: ['5piece'],
  },
  {
    id: 21,
    number: '21',
    image: require('@/pages/rubik/images/img98.png'),
    algorithm: `(RU2R'<span class="mainColor2">U'</span>)[SX]<br/>(R<span class="mainColor2">U'</span>R')`,
    note: '<span style="color: #00a650">OR</span> F[SX]3F\'',
    scramble: '21',
    scrambleClass: 'scramblok',
    categories: ['5piece', 'crossshape'],
  },
  {
    id: 22,
    number: '22',
    image: require('@/pages/rubik/images/img104.png'),
    algorithm: `(R<span class="mainColor3">U'</span><span class="mainColor2">U'</span>)(R'2<span class="mainColor2">U'</span>)(R2<span class="mainColor2">U'</span>)(R'2<span class="mainColor2">U'</span>)(<span class="mainColor3">U'</span>R)`,
    scramble: '22',
    scrambleClass: 'scramblok',
    categories: ['5piece', 'crossshape'],
  },
  {
    id: 23,
    number: '23',
    image: require('@/pages/rubik/images/img110.png'),
    algorithm: `(R2<span class="mainColor">D'</span>)(R<span class="mainColor3">U'</span><span class="mainColor2">U'</span>R'<span class="mainColor">D</span>)(R<span class="mainColor3">U'</span><span class="mainColor2">U'</span>R)`,
    scramble: "R'U2R'D'<br/>R U2 R'<br/>D R2",
    scrambleClass: 'scramblok',
    categories: ['5piece', '2missing'],
  },
  {
    id: 24,
    number: '24',
    image: require('@/pages/rubik/images/img116.png'),
    algorithm: `(rUR'<span class="mainColor2">U'</span>)(r'FR<span class="mainColor3">F'</span>)`,
    scramble: '25+U2',
    scrambleClass: 'scramblok',
    categories: ['5piece', '2missing'],
  },
  {
    id: 25,
    number: '25',
    image: require('@/pages/rubik/images/img70.png'),
    algorithm: `<span class="mainColor3">F'</span>(rUR'<span class="mainColor2">U'</span>)(r'FR)`,
    scramble: '23+U2',
    scrambleClass: 'scramblok',
    categories: ['5piece', '2missing'],
  },
  {
    id: 26,
    number: '26',
    image: require('@/pages/rubik/images/img76.png'),
    algorithm: `(R<span class="mainColor3">U'</span><span class="mainColor2">U'</span>)(R'<span class="mainColor2">U'</span>R<span class="mainColor2">U'</span>R')`,
    scramble: "(RUR'U)(RU2R')",
    scrambleClass: 'scramblok',
    categories: ['5piece', '3missing'],
  },
  {
    id: 27,
    number: '27',
    image: require('@/pages/rubik/images/img82.png'),
    algorithm: `(RUR'<span class="mainColor">U</span>)(R<span class="mainColor3">U'</span><span class="mainColor2">U'</span>R')`,
    scramble: "(RU2R')(U'RU'R')",
    scrambleClass: 'scramblok',
    categories: ['5piece', '3missing'],
  },
  {
    id: 28,
    number: '28',
    image: require('@/pages/rubik/images/img88.png'),
    algorithm: `(rUR'<span class="mainColor2">U'</span>)(MU)<br/>(R<span class="mainColor2">U'</span>R')`,
    scramble: '57',
    scrambleClass: 'scramblok',
    categories: ['5piece', '2missing'],
  },
  {
    id: 29,
    number: '29',
    image: require('@/pages/rubik/images/img93.png'),
    algorithm: `[SX](R<span class="mainColor2">U'</span>R'<span class="mainColor3">F'</span><span class="mainColor2">U'</span>F)(RUR')`,
    scramble: "(RU'R')(F'UFRUR')(URU'R')",
    scrambleClass: 'scramble',
    categories: ['5piece', 'rocketshape'],
  },
  {
    id: 30,
    number: '30',
    image: require('@/pages/rubik/images/img66.png'),
    algorithm: `f(RU)(R2<span class="mainColor2">U'</span>R'U)(R2<span class="mainColor2">U'</span>R')<span class="mainColor3">f'</span>`,
    scramble: "f(RUR2)(U'RUR2)(U'R')f'",
    scrambleClass: 'scramble',
    categories: ['5piece', 'rocketshape'],
  },
  {
    id: 31,
    number: '31',
    image: require('@/pages/rubik/images/img99.png'),
    algorithm: `(r'<span class="mainColor3">F'UF</span>)(r<span class="mainColor2">U'</span>r'<span class="mainColor2">U'</span>r)`,
    scramble: "38+U' or 40+U2",
    scrambleClass: 'scramble',
    categories: ['5piece', 'buildingshape'],
  },
  {
    id: 32,
    number: '32',
    image: require('@/pages/rubik/images/img105.png'),
    algorithm: `(l F U' F')(l' U l U l')`,
    algorithmOld: `(RU)(<span class="mainColor3">B'</span><span class="mainColor2">U'</span>)(R'URBR')`,
    scramble: '36 or 39',
    scrambleClass: 'scramble',
    categories: ['5piece'],
  },
  {
    id: 33,
    number: '33',
    image: require('@/pages/rubik/images/img111.png'),
    algorithm: `[SX]<br/>[sh]`,
    scramble: '37',
    scrambleClass: 'scramblok',
    categories: ['5piece', 'tshape'],
  },
  {
    id: 34,
    number: '34',
    image: require('@/pages/rubik/images/img117.png'),
    algorithm: `(RUR2<span class="mainColor2">U'</span>)(R'F)(RUR<span class="mainColor2">U'</span><span class="mainColor">F'</span>)`,
    scramble: "FUR'U'R'<br/>F'R<br/>UR2U'R'",
    scrambleClass: 'scramble_orange',
    categories: ['5piece', 'cshape'],
  },
  {
    id: 35,
    number: '35',
    image: require('@/pages/rubik/images/img71.png'),
    algorithm: `RU2R'<br/>[sh]<br/>RU2R'`,
    scramble: "RU2R'<br/>FR'F'R<br/>RU2R'",
    scrambleClass: 'scramble_orange',
    categories: ['5piece'],
  },
  {
    id: 36,
    number: '36',
    image: require('@/pages/rubik/images/img77.png'),
    algorithm: `(L' U' L U')(L' U L U)<br/>[sh left]`,
    algorithmOld: `(R'<span class="mainColor2">U'</span>R<span class="mainColor2">U'</span>)(R'URU)(l<span class="mainColor2">U'</span>R'U)`,
    scramble: "(B'RBR')(U'R'U'R)(UR'UR)",
    scrambleClass: 'scramble',
    categories: ['5piece'],
    cssOll: 'rotate180',
  },
  {
    id: 37,
    number: '37',
    image: require('@/pages/rubik/images/img83.png'),
    algorithm: `F(R<span class="mainColor2">U'</span>R'<span class="mainColor2">U'</span>)(RUR'<span class="mainColor3">F'</span>)`,
    scramble: '33 or 34 or 35+U',
    scrambleClass: 'scramblok',
    categories: ['5piece'],
  },
  {
    id: 38,
    number: '38',
    image: require('@/pages/rubik/images/img89.png'),
    algorithm: `(RUR'U)(R<span class="mainColor2">U'</span>R'<span class="mainColor2">U'</span>)<br/>[sh]`,
    scramble: "FR'F'R U [SX] RU'R'",
    scrambleClass: 'scramble_orange',
    categories: ['5piece', 'buildingshape'],
  },
  {
    id: 39,
    number: '39',
    image: require('@/pages/rubik/images/img94.png'),
    algorithm: `L<br/>F'[SX left]F<br/>(U' L')`,
    algorithmOld: `(RUR'<span class="mainColor3">F'</span><span class="mainColor2">U'</span>F)U(RU2R')`,
    scramble: '32',
    scrambleClass: 'scramble',
    categories: ['5piece'],
    cssOll: 'rotate180',
  },
  {
    id: 40,
    number: '40',
    image: require('@/pages/rubik/images/img94_2.png'),
    algorithm: `R'<br/>F[SX]<span class="mainColor3">F'</span><br/>(UR)`,
    scramble: '31+U2',
    scrambleClass: 'scramble',
    categories: ['5piece', 'buildingshape'],
  },
  {
    id: 41,
    number: '41',
    image: require('@/pages/rubik/images/img100.png'),
    algorithm: `(RUR'<span class="mainColor">U</span>)(R<span class="mainColor3">U'</span><span class="mainColor2">U'</span>R')<br/>F[SX]<span class="mainColor3">F'</span>`,
    scramble: '42',
    scrambleClass: 'scramble_orange',
    categories: ['5piece', 'rocketshape'],
  },
  {
    id: 42,
    number: '42',
    image: require('@/pages/rubik/images/img106.png'),
    algorithm: `(R'<span class="mainColor2">U'</span>R<span class="mainColor2">U'</span>)(R'U2R)<br/>F[SX]<span class="mainColor3">F'</span>`,
    scramble: "F(URU'R')F'(R'U2R)(UR'UR)",
    scrambleClass: 'scramble_orange',
    categories: ['5piece', 'rocketshape'],
  },
  {
    id: 43,
    number: '43',
    image: require('@/pages/rubik/images/img112.png'),
    algorithm: `f' [SX left] f</span>`,
    algorithmOld: `R'U'F'<br/>UFR`,
    scramble: "41 or 46+U'",
    scrambleClass: 'scramblok',
    categories: ['5piece'],
  },
  {
    id: 44,
    number: '44',
    image: require('@/pages/rubik/images/img118.png'),
    algorithm: `f[SX]<span class="mainColor3">f'</span>`,
    scramble: "45+U2 or 29+U2 or 30+U'",
    scrambleClass: 'scramblok',
    categories: ['5piece'],
  },
  {
    id: 45,
    number: '45',
    image: require('@/pages/rubik/images/img72.png'),
    algorithm: `F[SX]<span class="mainColor3">F'</span>`,
    scramble: '44+U2 or 43',
    scrambleClass: 'scramblok',
    categories: ['5piece', 'tshape'],
  },
  {
    id: 46,
    number: '46',
    image: require('@/pages/rubik/images/img78.png'),
    algorithm: `(R'<span class="mainColor2">U'</span>)[sh]<br/>(U R)`,
    scramble: "R'U'<br/>FR'F'R<br/>UR",
    scrambleClass: 'scramblok',
    categories: ['5piece', 'cshape'],
  },
  {
    id: 47,
    number: '47',
    image: require('@/pages/rubik/images/img84.png'),
    algorithm: `F' [SX left]2 F`,
    algorithmOld: `<span class="mainColor3">b'</span>(<span class="mainColor2">U'</span>R'UR)2b`,
    scramble: "f' [SX left]2 f",
    scrambleOld: "b'<br/>(R'U'RU)2<br/>b",
    scrambleClass: 'scramble',
    categories: ['3piece', 'lshape2'],
  },
  {
    id: 48,
    number: '48',
    image: require('@/pages/rubik/images/img90.png'),
    algorithm: `F [SX]2 <span class="mainColor3">F'</span>`,
    scramble: "f [SX]2 f'",
    scrambleClass: 'scramble_orange',
    categories: ['3piece'],
  },
  {
    id: 49,
    number: '49',
    image: require('@/pages/rubik/images/img95.png'),
    algorithm: `(R<span class="mainColor3">B'</span>)(R'2FR2B)(R'2<span class="mainColor3">F'</span>R)`,
    scramble: '50+U2',
    scrambleClass: 'scramble',
    categories: ['3piece'],
  },
  {
    id: 50,
    number: '50',
    image: require('@/pages/rubik/images/img95_2.png'),
    algorithm: `(r'U)(r2<span class="mainColor2">U'</span>r'2<span class="mainColor2">U'</span>)(r2Ur')`,
    scramble: '49+U2',
    scrambleClass: 'scramble',
    categories: ['3piece'],
  },
  {
    id: 51,
    number: '51',
    image: require('@/pages/rubik/images/img101.png'),
    algorithm: `f[SX]2<span class="mainColor3">f'</span>`,
    scramble: '48+U2 or 47',
    scrambleClass: 'scramblok',
    categories: ['3piece', 'lineshape'],
  },
  {
    id: 52,
    number: '52',
    image: require('@/pages/rubik/images/img107.png'),
    algorithm: `(R'<span class="mainColor3">F'</span><span class="mainColor2">U'</span>F<span class="mainColor2">U'</span>)(RUR'<span class="mainColor">U</span>R)`,
    scramble: '52+U2',
    scrambleClass: 'scramble',
    categories: ['3piece', 'lineshape'],
  },
  {
    id: 53,
    number: '53',
    image: require('@/pages/rubik/images/img113.png'),
    algorithm: `(l' U' l)<br/>[SX left]2<br/>(l' U l)`,
    algorithmOld: `(r'U2)<br/>[SX]<br/>(RUR'Ur)`,
    scramble: '53+U',
    scrambleClass: 'scramble_learn',
    categories: ['3piece', 'lshape2'],
    cssOll: 'rotate180',
  },
  {
    id: 54,
    number: '54',
    image: require('@/pages/rubik/images/img119.png'),
    algorithm: `(r U r')<br/>[SX]2<br/>(r <span class="mainColor2">U'</span> r')`,
    scramble:
      "(rUr')(UR<span class=\"mainColor2\">U'</span>R')2(r<span class=\"mainColor2\">U'</span>r')",
    scrambleClass: 'scramble_orange',
    categories: ['3piece', 'lshape2'],
  },
  {
    id: 55,
    number: '55',
    image: require('@/pages/rubik/images/img73.png'),
    algorithm: `(r<span class="mainColor3">U'</span><span class="mainColor2">U'</span>R'<span class="mainColor2">U'</span>)M [SX]<br/>(r<span class="mainColor2">U'</span>r')`,
    scramble: "(rUr'U)(RU'R')(M'URU2r')",
    scrambleClass: 'scramble_orange',
    categories: ['3piece'],
  },
  {
    id: 56,
    number: '56',
    image: require('@/pages/rubik/images/img79.png'),
    algorithm: `(rUr')(UR<span class="mainColor2">U'</span>R')2(r<span class="mainColor2">U'</span>r')`,
    scramble: '54',
    scrambleClass: 'scramble_orange',
    categories: ['3piece', 'lshape2'],
  },
  {
    id: 57,
    number: '57',
    image: require('@/pages/rubik/images/img85.png'),
    algorithm: `[SX]<span class="mainColor">M'</span>(UR<span class="mainColor2">U'</span>r')`,
    note: '<span style="color: #00a650">OR</span> U f[SX]f\' U2 f[SX]f\'',
    scramble: "F[SX]F' U2 F[SX]F' U<br/>or 28",
    scrambleClass: 'scramblok',
    categories: ['3piece'],
  },
];

export const ollCategories = {
  all: { label: 'Show All', items: 'all' },
  '1piece': { label: '1 Piece', items: [1, 2] },
  '2piece': { label: '2 Pieces', items: [3, 4] },
  '3piece': {
    label: '3 Pieces',
    items: [17, 18, 19, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56],
  },
  '4piece': {
    label: '4 Pieces',
    items: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
  },
  '5piece': {
    label: '5 Pieces',
    items: [
      20, 21, 22, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43,
      44, 45, 46,
    ],
  },
  '3missing': { label: '3 Missing', items: [26, 27] },
  '2missing': { label: '2 Missing', items: [23, 24, 25, 28, 57] },
  rocketshape: { label: 'Rocket', items: [29, 30, 41, 42] },
  lshape1: { label: 'L Shape 1', items: [13, 14, 15, 16] },
  lshape2: { label: 'L Shape 2', items: [47, 48, 49, 50, 53, 54] },
  lineshape: { label: 'Line', items: [17, 51, 52, 55, 56] },
  sshape: { label: 'S Shape', items: [7, 8, 11, 12] },
  buildingshape: { label: 'Building', items: [31, 32, 43, 44] },
  tshape: { label: 'T Shape', items: [33, 45] },
  crossshape: { label: 'Cross', items: [21, 22] },
  cshape: { label: 'C Shape', items: [34, 46] },
  tolearn: {
    label: 'To Learn',
    items: [9, 10, 15, 16, 19, 31, 35, 37, 38, 40, 46, 52, 54, 55, 56],
  },
  tolearn2: {
    label: 'To Learn 2',
    items: [1, 9, 10, 17, 19, 20, 28, 35, 37, 38, 41, 42, 46, 55, 56, 57],
  },
};
